import {
  Box,
  Center,
  Flex,
  Text,
  Tooltip,
  useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';

import { Icon } from 'packages/common-frontend/components/icons';

export const SideBarHeader: React.FC<{
  headerLabel: string;
  onClickPrevious: () => void;
  iconOnly?: boolean | undefined;
}> = ({ headerLabel, onClickPrevious, iconOnly }) => {
  const toolTipBgColor = useColorModeValue('black', 'white');
  const toolTipColor = useColorModeValue('white', 'black');

  return (
    <Box>
      <Flex alignItems="center" padding="8px 8px">
        {iconOnly ? (
          <Tooltip
            label={headerLabel}
            placement="right"
            gutter={12}
            bgColor={toolTipBgColor}
            color={toolTipColor}
            borderRadius="4px"
            px="8px"
            py="4px"
          >
            <Box onClick={onClickPrevious} cursor="pointer">
              <Center>
                <Icon icon="x" />
              </Center>
            </Box>
          </Tooltip>
        ) : (
          <Flex
            alignItems="center"
            onClick={onClickPrevious}
            cursor="pointer"
            width="full"
          >
            <Box mr="16px">
              <Icon icon="x" />
            </Box>
            <Text fontSize="16px" fontWeight={500}>
              {headerLabel}
            </Text>
          </Flex>
        )}
      </Flex>
    </Box>
  );
};
